import { render } from "./LayoutWrapper.vue?vue&type=template&id=98aefcf4"
import script from "./LayoutWrapper.vue?vue&type=script&lang=js"
export * from "./LayoutWrapper.vue?vue&type=script&lang=js"

import "./LayoutWrapper.vue?vue&type=style&index=0&id=98aefcf4&lang=scss"
script.render = render

export default script